import { makeRemoteResourceProvider } from '@recordset-local/core/web/resources/ResourceContext'

export const ResourceProvider = makeRemoteResourceProvider()
